export const MAX_USER_FULL_NAME_LENGTH = 50;

export { USER_ROLE_IDS } from '@futrli/views/processors/users/constants';
